module.exports = __webpack_public_path__ + "29713762c01fc7079982c1b63301cfe9.svg";